import type { FaireProductEntity } from "../../entity_types/product";

export const p_yzq5bsjvdz: FaireProductEntity = {
  token: "p_yzq5bsjvdz",
  type: "product",
  name: "Yellow Linen Journal",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/92cf72c74b74470210af1ba7ac12920cf52a062b8d34c281fc1d4f4643f230b7.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/f5a500999949d0836192fcf68d25184c34510a68a993257ef7a9038a478111eb.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
